import { render, staticRenderFns } from "./CDateTimePicker.vue?vue&type=template&id=17b60894"
import script from "./CDateTimePicker.vue?vue&type=script&lang=js"
export * from "./CDateTimePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b60894')) {
      api.createRecord('17b60894', component.options)
    } else {
      api.reload('17b60894', component.options)
    }
    module.hot.accept("./CDateTimePicker.vue?vue&type=template&id=17b60894", function () {
      api.rerender('17b60894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/CDateTimePicker.vue"
export default component.exports